// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__ypgLJ","link":"style_link__HPaLg"};